package features.teams.ui

import kotlinx.html.*
import kotlinx.html.js.onClickFunction
import features.teams.domain.Team
import features.teams.handlers.showEditTeamNameModal
import features.teams.handlers.showEditTeamAvatarModal
import features.teams.handlers.showArchiveTeamModal

object SettingsTab {
    fun render(parent: DIV, team: Team) {
        parent.div {
            h2("text-2xl font-bold mb-6") { +"Team Settings" }
            
            // Team Information Section
            div("bg-dark-800 rounded-2xl p-6 border border-dark-700 mb-6") {
                h3("text-lg font-bold mb-4 flex items-center gap-2") {
                    span { +"📋" }
                    +"Team Information"
                }
                
                // Team Name
                div("mb-6") {
                    label("block text-sm text-slate-400 mb-2") { +"Team Name" }
                    div("flex items-center gap-3") {
                        div("flex-1 bg-dark-900 border border-dark-700 rounded-xl p-3 text-white") {
                            +team.name
                        }
                        button(classes = "px-4 py-2 bg-dark-700 hover:bg-dark-600 text-white rounded-lg font-medium transition") {
                            onClickFunction = { showEditTeamNameModal(team) }
                            +"Edit"
                        }
                    }
                }
                
                // Team Avatar
                div {
                    label("block text-sm text-slate-400 mb-2") { +"Team Avatar" }
                    div("flex items-center gap-4") {
                        div("w-20 h-20 rounded-xl bg-dark-700 border border-dark-600 flex items-center justify-center overflow-hidden shrink-0") {
                            if (team.avatar != null && team.avatar.isNotBlank()) {
                                // Avatar already contains the full data URL with prefix
                                img(src = team.avatar) {
                                    classes = setOf("w-full", "h-full", "object-cover")
                                }
                            } else {
                                span("text-3xl") { +"🏢" }
                            }
                        }
                        button(classes = "px-4 py-2 bg-dark-700 hover:bg-dark-600 text-white rounded-lg font-medium transition") {
                            onClickFunction = { showEditTeamAvatarModal(team) }
                            +"Change Avatar"
                        }
                    }
                }
            }
            
            // Danger Zone
            div("bg-red-500/5 border border-red-500/20 rounded-2xl p-6") {
                h3("text-lg font-bold mb-4 flex items-center gap-2 text-red-400") {
                    span { +"⚠️" }
                    +"Danger Zone"
                }
                
                if (!team.isArchived) {
                    div("mb-4") {
                        h4("font-bold text-white mb-1") { +"Archive Team" }
                        p("text-sm text-slate-400 mb-3") {
                            +"Archived teams are read-only. Members cannot make any changes."
                        }
                        button(classes = "px-4 py-2 bg-red-500/10 hover:bg-red-500/20 text-red-400 border border-red-500/30 rounded-lg font-medium transition") {
                            onClickFunction = { showArchiveTeamModal(team) }
                            +"Archive Team"
                        }
                    }
                } else {
                    div("bg-orange-500/10 border border-orange-500/30 rounded-lg p-4") {
                        div("flex items-center gap-2 text-orange-400 mb-2") {
                            span { +"📦" }
                            span("font-bold") { +"Team is Archived" }
                        }
                        p("text-sm text-slate-400") {
                            +"This team is currently archived and read-only."
                        }
                    }
                }
            }
        }
    }
}
